// The Telegram account a binding names, as the "Your Telegram" card shows it
// (users-ui.jsx's MyTelegramCard; review NEW-1). No node, no window -- this
// file is `node --test`able.
//
// THREE labelled slots, in this order, never one string. The numeric id and
// the @username are Telegram's: the id is the account, and the @username is
// unique and keeps Telegram's own shape (app/users/contact.py's
// telegram_username drops anything else, so it can hold no space, '@', dash
// or id). The first name is the account's own words -- anyone can set theirs
// to "Boss @boss_phone - id 1001". Joined into one string, that name made a
// stranger's pending account read exactly like the admin's; in its own slot,
// last, quoted and labelled unverified, it cannot put text into the id or
// the @username slot.

const WORDS = {
  en: { id: 'id', username: '@username', none: 'no @username',
        name: 'name (set by the account, not verified)' },
  he: { id: 'מזהה', username: '@username', none: 'ללא @username',
        name: 'שם (נקבע בחשבון, לא מאומת)' },
};

// account: {id, username, name} as GET /api/v1/auth/me/telegram returns it
// (username null when the account has none). he: the page's language.
export function accountSlots(account, he) {
  const w = he ? WORDS.he : WORDS.en;
  const a = account || {};
  return [
    { key: 'id', label: w.id, value: String(a.id) },
    { key: 'username', label: w.username, value: a.username ? `@${a.username}` : w.none },
    { key: 'name', label: w.name, value: `"${a.name || ''}"` },
  ];
}

// Whether the t.me link a POST /auth/me/telegram just returned is still
// worth showing: 'live', 'expired' or 'hidden'.
//
// `link_open` is the SERVER's answer (contact.telegram_card ->
// _still_open over the bind code's own expiry), not "a link was once
// handed out" -- the card holds its link object for as long as the page
// stays open, so without this a ten-minute-dead link would keep reading as
// live and the admin would wait on a /start that can no longer arrive.
// Once an account IS pending the link has done its job and the confirm box
// is what matters, so it is hidden rather than expired.
export function bindLinkView(state, link) {
  if (!link || !state) return 'hidden';
  if (state.pending) return 'hidden';
  return state.link_open ? 'live' : 'expired';
}
